/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Teams_Create_Team_Label_NameInputs */



/**
* | output |
* | --- |
* | "Team Name" |
*
* @param {Teams_Create_Team_Label_NameInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const teams_create_team_label_name = /** @type {((inputs?: Teams_Create_Team_Label_NameInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Teams_Create_Team_Label_NameInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Team Name")
	return /** @type {LocalizedString} */ ("Team Name")
});